import styled from "@emotion/styled";

export const MergeSuppliersModalContainer = styled.div`
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  gap: 40px;
`;
